import './Fatturazione.css';
import Fnc from '../../library/Functions'
import React, { useState, useEffect } from 'react';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import LbsSelect from "../LbsSelect"
import SeceltaCommissione from './SceltaCommissione';
import { isCommissionSelectable } from './CommissionUtils';
import EmailInp from "../EmailInp"
import PivaInp from "../PivaInp"
import CfInp from "../CfInp"
import PhoneInp from "../PhoneInp"
import SdiInp from "../SdiInp"
import DefInp from "../DefInp"
import DialogMsg from '../DialogMsg';


function Fatturazione(props) {

  // {"sdi":"0000000","nam":"Mario","snam":"Rossi","comp":"Mia azienda",
  // "rs":"Mia azienda","city":"Rho","fz":"","prov":"MI","topo":"via Antonio Rosmini",
  // "zip":"20017","num":"","ivacf":"77224360881","type":"N","cc":{},"iva":"77224360881",
  // "cf":"","fCond":true,"fProm":false,"gtw":null}

  //const [, updateState] = React.useState();
  //const forceUpdate = React.useCallback(() => updateState({}), []);

  const DEF_NAM = "Nome";
  const DEF_SNAM = "Cognome";
  const DEF_SDI = "0000000";

  const [isLogged, setIsLogged] = useState(false);
  //const [isTimeToFillData, setIsTimeToFillData] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [invoiceData, setInvoiceData] = useState({
    "iva": null,
    "cf": null,
    "ivacf": null,
    "rs": null,
    "comp": null,
    "nam": null,
    "snam": null,
    "city": null,
    "fz": null,
    "prov": null,
    "topo": null,
    "zip": null,
    "num": null,
    "sdi": null,
    "email": null,
    "type": "N",
    "cc": {},
    "fCond": false,
    "fProm": false,
    "gtw": null,
    "phone": null,
    "timeSlot": null,
    "from": null
  });
  const [invoiceHash, setInvoiceHash] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);
  const [forceDisabled, setForceDisabled] = useState(true);
  const [dlgConf, setDlgConf] = useState(null);
  const [isWorking, setIsWorking] = useState(false);

  useEffect(() => {
    // Similar to componentDidMount and componentDidUpdate:
    if (props.user && props.user.response.code === 'OK') {
      setIsLogged(true);
    }

    Fnc.log("[INVOICE]", invoiceData, Fnc.LogLvl.DEBUG);

    if (props.customer !== null && invoiceHash === null) {
      //ho un customer già caricato, aggiorno invoice di conseguenza. N.B. L'input PIVA aggiorna solo su modifica!
      manageCustomer(props.customer);
    }

  }, [invoiceHash, props.validBasket, props.user, props.customer, props.bskType]); //empty array => chiama solo una volta. con un valore nell'array la chiama ad ogni cambiamento di quel valore/i

  function createInvoceHash(invoiceData) {
    return Fnc.jsonSerialize(invoiceData);
  }

  /**
   * Aggiornamento centralizzato e robusto di invoiceData.
   *
   * Serve per evitare che callback asincrone, ad esempio EmailInp o PhoneInp,
   * clonino una versione vecchia di invoiceData e sovrascrivano modifiche
   * fatte nel frattempo da checkbox, PIVA, indirizzo, nome, ecc.
   *
   * Mantiene invoiceHash perché viene usato come trigger di validazione.
   */
  function updateInvoiceData(mutator) {
    setValidationErrors([]);
    setInvoiceData(prevInvoiceData => {
      const cloneInvoiceData = Object.assign({}, prevInvoiceData);
      mutator(cloneInvoiceData);
      setInvoiceHash(createInvoceHash(cloneInvoiceData));
      return cloneInvoiceData;
    });
  }

  function handleNext(e) {
    if (e) e.preventDefault();

    const errors = getInvoiceValidationErrors(invoiceData);
    setValidationErrors(errors);

    if (errors.length > 0) {
      setDlgConf(new Fnc.DlgConf(
        "Controlla i dati inseriti",
        "Per continuare correggi:<br>• " + errors.join("<br>• "),
        false,
        "Chiudi",
        ""
      ));
      return;
    }

    const dataToSend = Object.assign({}, invoiceData);

    dataToSend.nam = dataToSend.nam && dataToSend.nam.length > 0 ? dataToSend.nam : DEF_NAM;
    dataToSend.snam = dataToSend.snam && dataToSend.snam.length > 0 ? dataToSend.snam : DEF_SNAM;
    dataToSend.sdi = dataToSend.sdi && dataToSend.sdi.length > 0 ? dataToSend.sdi : DEF_SDI;

    setSubmitting(true);
    props.callback(new Fnc.Ret(Fnc.EnmGen.OK, dataToSend));
  }

  function getInvoiceValidationErrors(data) {
    const errors = [];
    const paidBasket = props.bskType === Fnc.BasketType.PAY
      || props.bskType === Fnc.BasketType.BOTH;
    const privateCustomer = Boolean(props.customer
      && props.customer.invoicingData
      && props.customer.invoicingData.privato === true);
    const loggedUser = isLogged || Boolean(props.user
      && props.user.response
      && props.user.response.code === 'OK');
    const hasText = value => typeof value === 'string' && value.trim().length > 0;

    if (isWorking) errors.push("attendi il completamento della verifica dell'email");
    if (paidBasket && !data.fCond) errors.push('accetta le condizioni generali di servizio');

    if (paidBasket && privateCustomer
      && Fnc.validateCf(data.cf) !== Fnc.EnmCf.OK) {
      errors.push('inserisci un codice fiscale valido');
    }

    if (paidBasket && !privateCustomer
      && Fnc.validatePiva(data.iva) !== Fnc.EnmPiva.OK) {
      errors.push('inserisci una partita IVA valida');
    }

    if (!hasText(data.rs)) errors.push('inserisci la ragione sociale');
    if (paidBasket && !hasText(data.city)) errors.push('seleziona il comune');
    if (paidBasket && !hasText(data.prov)) errors.push('seleziona la provincia');
    if (paidBasket && !hasText(data.topo)) errors.push("seleziona l'indirizzo di fatturazione");
    if (!hasText(data.nam)) errors.push('inserisci il nome');
    if (!hasText(data.snam)) errors.push('inserisci il cognome');

    if (Fnc.validateEmail(data.email) !== Fnc.EnmEmail.OK) {
      errors.push("inserisci e verifica un'email valida");
    }

    if (paidBasket && hasText(data.sdi)
      && Fnc.validateSdi(data.sdi) !== Fnc.EnmSdi.OK) {
      errors.push('inserisci un codice destinatario valido oppure lascialo vuoto');
    }

    const validPhone = hasText(data.phone)
      && /^[0-9+()./\s-]+$/.test(data.phone)
      && Fnc.gValidatePhone(data.phone, 'IT').code === Fnc.EnmPhone.OK;

    if (!loggedUser && !validPhone) {
      errors.push('inserisci un numero di telefono valido');
    }

    if (!props.validBasket) errors.push('il carrello non risulta valido: aggiorna la pagina e riprova');

    return errors;
  }

  function callbackCustomerIva(data) {
    Fnc.log("[PIVA]", invoiceData, Fnc.LogLvl.DEBUG);

    if (data.code === Fnc.EnmPiva.OK) {
      let customer = data.obj;
      manageCustomer(customer);
      setForceDisabled(true);
    } else if (data.code === Fnc.EnmPiva.NOT_FOUND) {
      let pivaVal = data.obj;

      updateInvoiceData(cloneInvoiceData => {
        cloneInvoiceData.iva = pivaVal;
        cloneInvoiceData.cf = "";
        //cloneInvoiceData.ivacf = pivaVal;
      });

      setForceDisabled(false);
    }
  }

  function callbackCustomerCf(data) {
    Fnc.log("[CF]", invoiceData, Fnc.LogLvl.DEBUG);

    if (data.code === Fnc.EnmCf.OK) {
      let customer = data.obj;
      manageCustomer(customer);
      setForceDisabled(true);
    } else if (data.code === Fnc.EnmCf.NOT_FOUND) {
      let cfVal = data.obj;

      updateInvoiceData(cloneInvoiceData => {
        cloneInvoiceData.cf = cfVal;
        cloneInvoiceData.iva = "";
        //cloneInvoiceData.ivacf = cfVal;
      });

      setForceDisabled(false);
    }
  }

  function manageCustomer(customer) {
    if (customer && customer.invoicingData) {

      let address = customer.invoicingData["indirizzo"];
      let addParsed = Fnc.cleanAddress(address);

      updateInvoiceData(cloneInvoiceData => {
        if (customer.invoicingData["privato"] === true) {
          cloneInvoiceData.cf = customer.invoicingData["cf"];
          //cloneInvoiceData.ivacf = customer.invoicingData["cf"];
        } else {
          cloneInvoiceData.iva = customer.invoicingData["piva"];
          //cloneInvoiceData.ivacf = customer.invoicingData["piva"];
        }

        cloneInvoiceData.rs = customer.invoicingData["ragSoc"];
        cloneInvoiceData.comp = customer.invoicingData["ragSoc"];
        cloneInvoiceData.nam = customer.invoicingData["name"];
        cloneInvoiceData.snam = customer.invoicingData["surname"];
        cloneInvoiceData.city = customer.invoicingData["citta"];
        cloneInvoiceData.fz = customer.invoicingData["frazione"];
        cloneInvoiceData.prov = customer.invoicingData["provincia"];
        cloneInvoiceData.topo = addParsed.topo;
        cloneInvoiceData.num = addParsed.civico;
        cloneInvoiceData.zip = customer.invoicingData["cap"];
        cloneInvoiceData.sdi = customer.invoicingData["sdi"];
        cloneInvoiceData.email = props.user !== null && props.user.user !== null && props.user.user.email ? props.user.user.email : customer.invoicingData["email"];

        if (props.selComm != null) {
          cloneInvoiceData.cc = Object.assign({}, props.selComm);
          cloneInvoiceData.cc['products'] = null;
        }

        let from = Fnc.getCookie(Fnc.FROM_COOKIE_NAME);
        if (from !== null && from.length > 0) {
          cloneInvoiceData.from = from;
        }
      });
    }
  }

  function callbackCity(data) {
    Fnc.log("[CITY]", invoiceData, Fnc.LogLvl.DEBUG);

    updateInvoiceData(cloneInvoiceData => {
      if (data.code === Fnc.EnmGen.OK && data.obj.elm) {
        const cityChanged = cloneInvoiceData.city !== data.obj.elm.com
          || cloneInvoiceData.prov !== data.obj.elm.prov;
        cloneInvoiceData.city = data.obj.elm.com;
        cloneInvoiceData.prov = data.obj.elm.prov;
        cloneInvoiceData.fz = data.obj.elm.fraz;
        if (cityChanged) {
          cloneInvoiceData.topo = null;
          cloneInvoiceData.num = null;
        }
        //setTesttmp(data.elm.com);
      } else {
        cloneInvoiceData.city = null;
        cloneInvoiceData.prov = null;
        cloneInvoiceData.fz = null;
        cloneInvoiceData.topo = null;
        cloneInvoiceData.num = null;
      }
    });

    //forceUpdate();
  }

  function callbackAddress(data) {
    Fnc.log("[ADDRESS]", invoiceData, Fnc.LogLvl.DEBUG);

    updateInvoiceData(cloneInvoiceData => {
      if (data.code === Fnc.EnmGen.OK && data.obj && data.obj.elm) {
        let addParsed = Fnc.cleanAddress(data.obj.elm.topo);
        cloneInvoiceData.topo = addParsed.topo;
        cloneInvoiceData.num = addParsed.civico;
      } else {
        cloneInvoiceData.topo = null;
      }
    });

    //forceUpdate();
  }

  function getCity() {
    return invoiceData.city != null ? (invoiceData.fz ? invoiceData.fz + ", " : "") + invoiceData.city + " (" + invoiceData.prov + ")" : "";
  }

  function getAddress() {
    return invoiceData.topo != null ? (invoiceData.topo != null ? invoiceData.topo : "") + " " + (invoiceData.num != null ? invoiceData.num : "") : "";
  }

  function onCondPromChanged(e) {
    const checked = e.target.checked;

    updateInvoiceData(cloneInvoiceData => {
      cloneInvoiceData.fProm = checked;
    });
  }

  function onCondChanged(e) {
    const checked = e.target.checked;

    updateInvoiceData(cloneInvoiceData => {
      cloneInvoiceData.fCond = checked;
    });
  }

  function handleChooseContract(comm) {
    props.handleChooseContract(comm);
    //setIsTimeToFillData(true);
    if (props.user && props.user.response.code === 'OK') {
      //updateCustomer(props.user.user.pIva);
      setIsLogged(true);
    }
  }

  function callbackEmail(data) {
    Fnc.log("EMAIL:", data, Fnc.LogLvl.DEBUG);

    updateInvoiceData(cloneInvoiceData => {
      cloneInvoiceData.email = data.code === Fnc.EnmEmail.OK ? data.obj : null;
    });

    setIsWorking(false);
  }

  function callbackSdi(data) {
    Fnc.log("SDI:", data, Fnc.LogLvl.DEBUG);

    updateInvoiceData(cloneInvoiceData => {
      cloneInvoiceData.sdi = data.obj;
    });
  }

  function callbackRagSoc(data) {
    Fnc.log("RAGSOC:", data, Fnc.LogLvl.DEBUG);

    updateInvoiceData(cloneInvoiceData => {
      cloneInvoiceData.rs = data.obj;
      cloneInvoiceData.comp = data.obj;
    });
  }

  function callbackName(data) {
    Fnc.log("NAME:", data, Fnc.LogLvl.DEBUG);

    updateInvoiceData(cloneInvoiceData => {
      cloneInvoiceData.nam = data.obj;
    });
  }

  function callbackSurname(data) {
    Fnc.log("SURNAME:", data, Fnc.LogLvl.DEBUG);

    updateInvoiceData(cloneInvoiceData => {
      cloneInvoiceData.snam = data.obj;
    });
  }

  function callbackPhone(data) {
    Fnc.log("PHONE:", data, Fnc.LogLvl.DEBUG);

    updateInvoiceData(cloneInvoiceData => {
      if (data.code === Fnc.EnmPhone.OK) {
        cloneInvoiceData.phone = data.obj.raw;
      } else {
        cloneInvoiceData.phone = null;
      }
    });
  }

  function clickTimeSlot(e) {
    let val = e.target.value;

    let tmSlForInvocice = null;

    if (timeSlots.includes(val)) {
      var filtered = timeSlots.filter(function (value, index, arr) {
        return value !== val;
      });
      tmSlForInvocice = filtered.join("|");
      setTimeSlots(filtered);
    } else {
      let filtered = timeSlots.slice();
      filtered.push(val);
      tmSlForInvocice = filtered.join("|");
      setTimeSlots(filtered);
    }

    updateInvoiceData(cloneInvoiceData => {
      cloneInvoiceData.timeSlot = tmSlForInvocice;
    });
  }

  function showCondition(e) {
    e.preventDefault();
    setDlgConf(new Fnc.DlgConf("APPROVAZIONE SPECIFICA DELLE CLAUSOLE ai sensi degli artt. 1341 e 1342 Codice Civile.", "Ai sensi e per gli effetti degli artt. 1341 e 1342 c.c., dichiaro di aver letto attentamente e di approvare specificamente i seguenti articoli delle Condizioni Generali:<br><br> 3.1, 3.2.3, 3.2.4, 3.2.5 (Procedure di conclusione del Contratto ) ** , 4 (Corrispettivo), 5 (Durata – Recesso), 6 (Sospensione e Interruzione del Servizio e/o dell’Account), 7 (Responsabilità del Cliente e Proprietà Intellettuale), 8.2, 8.3, 8.4 (Obblighi, responsabilità di IOL - modifiche Condizioni Generali, 11 (Legge applicabile e foro competente), 13.3 (Cessione del Contratto).", false, "Ho letto", "", null, null, "small"));
  }

  function callbackIsWorking() {
    //serve per impedire che durante il check dell'email qualcuno flagghi il check sulle condizioni. 
    //Per un problema di sincronia, questo flag non verrebbe settato sui dati fatturazione e quindi non si abiliterebbe il bottone per proseguire
    setIsWorking(true);
  }

  return (
    <>
      {

        (isLogged && !props.selComm
          && props.user?.user?.commissionList?.commissions?.some(commission => isCommissionSelectable(commission))) ?
          <SeceltaCommissione user={props.user} handleChooseContract={handleChooseContract} />
          :

          <div className="iol-checkout-left-part col-xl-7 checkout-billing-panel">
            <div className="iol-checkout-left checkout-card">
              <div className="caption semibold"><span className="checkout-required-marker" aria-hidden="true">*</span> Campi obbligatori</div>
              <div className="checkout-data-title semibold">{(props.bskType === Fnc.BasketType.PAY || props.bskType === Fnc.BasketType.BOTH) ? "Inserisci i dati di fatturazione della tua azienda" : "Inserisci i tuoi dati di contatto"}</div>
              {(props.bskType === Fnc.BasketType.PREV) && <p className="heading-6">Un nostro consulente ti ricontatterà per i tuoi preventivi.</p>}
              <form className="row checkout-billing-form" onSubmit={handleNext} noValidate>
                <div className="form-group col-md-6">
                  {(props.customer && props.customer.invoicingData["privato"] === true) ?
                    <CfInp callback={callbackCustomerCf} cf={props.user ? props.user.user.pIva : invoiceData.cf} loadData={props.customer === null} isLogged={isLogged} required={props.bskType === Fnc.BasketType.PAY || props.bskType === Fnc.BasketType.BOTH} />
                    :
                    <PivaInp callback={callbackCustomerIva} iva={props.user ? props.user.user.pIva : invoiceData.iva} loadData={props.customer === null} isLogged={isLogged} required={props.bskType === Fnc.BasketType.PAY || props.bskType === Fnc.BasketType.BOTH} />
                  }
                </div>
                <div className="form-group col-md-6">
                  <DefInp label="Ragione sociale azienda" example="Es. Rossi S.r.l." required={true} forceDisabled={!isLogged ? props.bskType === Fnc.BasketType.PAY || props.bskType === Fnc.BasketType.BOTH ? forceDisabled : false : true} id="ragionesociale" callback={callbackRagSoc} value={invoiceData.rs} />
                </div>
                {(props.bskType === Fnc.BasketType.PAY || props.bskType === Fnc.BasketType.BOTH) &&
                  <>
                    <div className="form-group col-md-6">
                      <LbsSelect label="* Comune" forceDisabled={!isLogged ? forceDisabled : true} required={true} callback={callbackCity} value={getCity()} type="city" preAppendVal="" />
                    </div>
                    <div className="form-group col-md-6">
                      <LbsSelect label="* Indirizzo di fatturazione"
                        forceDisabled={!isLogged ? forceDisabled || !invoiceData.city || !invoiceData.prov : true}
                        required={true} callback={callbackAddress} value={getAddress()}
                        type="address" preAppendVal={invoiceData.city} />
                    </div>

                  </>
                }
                <div className="form-group col-md-6">
                  <DefInp label="Nome" example="Es. Mario" required={true} forceDisabled={false} id="Nome" callback={callbackName} value={invoiceData.nam} />
                </div>
                <div className="form-group col-md-6">
                  <DefInp label="Cognome" example="Es. Rossi" required={true} forceDisabled={false} id="Cognome" callback={callbackSurname} value={invoiceData.snam} />
                </div>
                {(props.bskType === Fnc.BasketType.PAY || props.bskType === Fnc.BasketType.BOTH) &&
                  <div className="form-group col-md-6">
                    <SdiInp callback={callbackSdi} sdi={invoiceData.sdi} />
                  </div>
                }
                <div className={(props.bskType === Fnc.BasketType.PAY || props.bskType === Fnc.BasketType.BOTH) ? "form-group col-md-6" : "form-group col-md-12"}>
                  <EmailInp callbackIsWorking={callbackIsWorking} callback={callbackEmail} email={(props.user !== null && props.user.user !== null && props.user.user.email) ? props.user.user.email : invoiceData.email} isLogged={isLogged} required={true} />
                </div>
                {(!isLogged) &&
                  <>
                    <div className="form-group col-md-12">
                      <PhoneInp callback={callbackPhone} phone={null} required={true} />
                    </div>
                  </>
                }
                {/*
                {(props.bskType === Fnc.BasketType.PREV || props.bskType === Fnc.BasketType.BOTH) &&
                  <>
                    <div className="form-group col-md-12">
                      <PhoneInp callback={callbackPhone} phone={null} required={true} />
                    </div>

                    <div className="iol-time-slot">
                      <div className="iol-time-slot-label semibold"> Fascia oraria per contatto</div>
                      <div className="iol-checkboxes row">
                        <label className="checkbox-button">
                          <input className="checkbox-button__input" id="choiceone" type="checkbox" value="Mattina" name="sceltaRicontatto1" onClick={clickTimeSlot} />
                          <span className="checkbox-button__control"></span>
                          <span className="checkbox-button__label">Mattina</span>
                        </label>
                        <label className="checkbox-button">
                          <input className="checkbox-button__input" id="choicetwo" type="checkbox" value="Primo pomeriggio" name="sceltaRicontatto2" onClick={clickTimeSlot} />
                          <span className="checkbox-button__control"></span>
                          <span className="checkbox-button__label">Primo pomeriggio</span>
                        </label>
                        <label className="checkbox-button">
                          <input className="checkbox-button__input" id="choicethree" type="checkbox" value="Tardo pomeriggio" name="sceltaRicontatto3" onClick={clickTimeSlot} />
                          <span className="checkbox-button__control"></span>
                          <span className="checkbox-button__label">Tardo pomeriggio</span>
                        </label>
                      </div>
                    </div>
                  </>
                }
                  */}
                <div className="privacy-label caption">Cliccando sul tasto “CONFERMA E PROCEDI” dichiari di accettare le condizioni di servizio* e di aver preso visione dell’informativa privacy*
                  {(props.bskType === Fnc.BasketType.PAY || props.bskType === Fnc.BasketType.BOTH) &&
                    <div className="iol-checkboxes">
                      <label className="checkbox-button">
                        <input className="checkbox-button__input" id="choice2" type="checkbox" name="choice2" onChange={onCondChanged} ></input>
                        <span className="checkbox-button__control"></span>
                      </label>
                      <span className="checkbox-button__label regLblCheck">Ai sensi e per gli effetti degli artt. 1341 e 1342 c.c., dichiaro di aver letto attentamente e di approvare specificatamente i <a className="fucsia-text" href="#"
                        onClick={showCondition}>seguenti articoli</a> delle Condizioni Generali.</span>
                    </div>
                  }
                  <div className="iol-checkboxes">
                    <label className="checkbox-button">
                      <input className="checkbox-button__input" id="choice1" type="checkbox" name="choice1" onChange={onCondPromChanged} ></input>
                      <span className="checkbox-button__control"></span>
                    </label>
                    <span className="checkbox-button__label regLblCheck">Voglio restare aggiornato sulle promozioni e i servizi di Italiaonline come descritto <a className="fucsia-text" href="/archivio/informativa-privacy/"
                      target="_blank">nell'informativa sulla privacy</a></span>
                  </div>
                </div>
                <div className="caption">* Per una lettura completa <a className="fucsia-text" href="/wp-content/plugins/iol-customize/docs/condizioni_generali_di_servizio_e_privacy.pdf" target="_blank">clicca qui</a></div>
                {validationErrors.length > 0 &&
                  <div className="iol-validation-summary col-12" role="alert" aria-live="assertive">
                    <div className="semibold">Controlla i seguenti dati:</div>
                    <ul>{validationErrors.map(error => <li key={error}>{error}</li>)}</ul>
                  </div>}
                <button className="fucsia-button semibold checkout-primary-action" type="submit" disabled={submitting}>
                  <svg className="checkout-primary-action__lock" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <rect x="5" y="10" width="14" height="11" rx="2" />
                    <path d="M8 10V7a4 4 0 0 1 8 0v3" />
                  </svg>
                  <span>{submitting ? 'Invio in corso...' : 'Conferma e procedi'}</span>
                  <svg className="checkout-primary-action__arrow" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="m9 5 7 7-7 7" />
                  </svg>
                </button>
              </form>
            </div>
            {dlgConf != null &&
              <DialogMsg conf={dlgConf} ></DialogMsg>
            }
          </div>
      }

    </>
  );
}

export default Fatturazione;
